import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DropdownFieldWUT } from '../../../ui/dropdown-field';
export const DropdownWUT = _ref => {
  let {
    options,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.DROPDOWN;
  const dropdownOptions = useMemo(() => (options || []).map(option => ({
    label: option.label,
    value: option.value ?? option.label
  })), [options]);
  return /*#__PURE__*/React.createElement(DropdownFieldWUT, _extends({}, rest, {
    fieldType: fieldType,
    options: dropdownOptions
  }));
};
//# sourceMappingURL=dropdown-wut.js.map